// author-liumingyang 2022-3-8  经分
import React, { useMemo } from 'react';
import { echartsContent } from '@/pages/opinion/utils';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { formatChartParamsDate } from '@/pages/opinion/components/ChartCommon/formatter';
import { percentageFormat, reviewsFormat } from '@/pages/opinion/utils/value';
import { baseColors, extendColors } from '@/pages/opinion/constants';
import { useIntl, getLocale } from 'umi';

interface chartInterFace {
  chartData: any;
  total: number;
}

const colorArr = [...baseColors, ...extendColors];

export default ({ chartData, total }: chartInterFace) => {
  const { formatMessage } = useIntl();
  const locale = getLocale();

  const seriesData = chartData
    .map((item: { count: number }, index: number) => ({
      ...item,
      value: item.count / total,
      itemStyle: {
        color: colorArr[0],
        barBorderRadius: 2,
      },
    }))
    .sort((a: { count: number }, b: { count: number }) => a.count - b.count);

  // 设置图形配置
  const makeupOptions = () => {
    const opts = {
      grid: {
        bottom: '0',
        right: '5%',
      },
      color: colorArr,
      tooltip: {
        formatter: (params: any) => {
          return formatChartParamsDate({
            title: params[0].name,
            params: params,
            listTitleFunc: () => formatMessage({ id: 'News Mentions' }),
            recordDealwith: (record, ele) => ({
              ...record,
              value: reviewsFormat(ele?.data?.count),
            }),
            dealwithRecords(records, total) {
              return records.map((item) => ({
                ...item,
                value: `${item.value}(${percentageFormat(total * 100)})`,
              }));
            },
          });
        },
      },
      yAxis: {
        position: 'left',
        axisLabel: {
          show: true,
          margin: 24,
          interval: 0,
        },
        splitLine: {
          show: false,
          lineStyle: { color: '#E5E5E5', type: 'dashed' },
        },
        axisLine: {
          show: false,
        },
        type: 'category',
        axisTick: {
          show: false,
        },
        gridIndex: 0,
        data: [...seriesData.map((item: { name: any }) => item.name)],
      },
      xAxis: {
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: '#000000',
            opacity: '0.25',
          },
        },
        boundaryGap: true,
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: { color: '#E5E5E5', type: 'dashed' },
        },
        axisLine: {
          show: true,
          lineStyle: { color: '#E5E5E5' },
        },
        axisLabel: {
          interval: 'auto',
          formatter: (value: number) => {
            return Math.round(value * 100) + '%';
          },
        },
      },
      series: [
        {
          name: 'rate',
          barMaxWidth: 30,
          type: 'bar',
          data: seriesData,
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            color: '#444',
            formatter: (params: { data: { count: any } }) => {
              return echartsContent(params?.data?.count);
            },
          },
        },
      ],
    };
    return opts;
  };

  const options = useMemo(() => {
    if (chartData.length === 0) {
      return {};
    }
    return makeupOptions();
  }, [chartData, locale]);

  return (
    <EChartCommon
      optionsProps={{ type: 'bar', excludeOptions: ['legend'] }}
      options={options}
      empty={chartData.length === 0}
      height={300}
    ></EChartCommon>
  );
};
